export * from './delete-confirm-icon.component'